import React from "react";
import { Button } from "../atoms";

const ICON_ONLY = "!min-w-0 !p-0 !shadow-none";
const PLAY_ICON = "!min-w-0 !p-2 !rounded-full";

function PlaybackControls({
  onSkipBackDouble,
  onFrameBack,
  onPlayPauseToggle,
  isPlaying,
  onFrameForward,
  onSkipForwardDouble,
  disabled = false,
  skipBackTooltip = "Retroceder Estimulo",
  frameBackTooltip = "Retroceder Frame",
  playPauseTooltip,
  frameForwardTooltip = "Avanzar Frame",
  skipForwardTooltip = "Avanzar Estimulo",
  className = "",
}) {
  const resolvedPlayPauseTooltip =
    playPauseTooltip || (isPlaying ? "Pausar" : "Reproducir");

  return (
    <div
      className={`inline-flex flex-none items-center justify-center gap-3 self-center rounded-full bg-surface-faded px-4 py-2 shadow-sm ${className}`}
    >
      <Button
        variant="ghost-icon"
        iconSize="sm"
        className={ICON_ONLY}
        icon="play-back-double"
        title={skipBackTooltip}
        aria-label={skipBackTooltip}
        onClick={onSkipBackDouble}
        disabled={disabled}
      />
      <Button
        variant="ghost-icon"
        iconSize="sm"
        className={ICON_ONLY}
        icon="play-back"
        title={frameBackTooltip}
        aria-label={frameBackTooltip}
        onClick={onFrameBack}
        disabled={disabled}
      />
      <Button
        variant="accent"
        iconSize="sm"
        className={PLAY_ICON}
        icon={isPlaying ? "pause" : "play"}
        title={resolvedPlayPauseTooltip}
        aria-label={resolvedPlayPauseTooltip}
        onClick={onPlayPauseToggle}
        disabled={disabled}
      />
      <Button
        variant="ghost-icon"
        iconSize="sm"
        className={ICON_ONLY}
        icon="play-forward"
        title={frameForwardTooltip}
        aria-label={frameForwardTooltip}
        onClick={onFrameForward}
        disabled={disabled}
      />
      <Button
        variant="ghost-icon"
        iconSize="sm"
        className={ICON_ONLY}
        icon="play-forward-double"
        title={skipForwardTooltip}
        aria-label={skipForwardTooltip}
        onClick={onSkipForwardDouble}
        disabled={disabled}
      />
    </div>
  );
}

export default PlaybackControls;